export default __webpack_public_path__ + "static/media/gallery-19.63339a8a.jpg";